import { PropsWithChildren } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRole } from "../../hooks/guard/useRole";
import { ROUTES } from "../../constants/routes";
import { useAuth } from "../../context/auth";

type RoleGuardProps = PropsWithChildren<{
  userRole?: number[];
  role?: number[];
}>;

const RoleGuard = (props: RoleGuardProps) => {
  const { user } = useAuth();
  const { role = [] } = props;
  const roleMatched = useRole([user?.roleId!], role);
    
  return (
    <>
      {roleMatched ? (
        <Outlet />
      ) : (
        <Navigate to={ROUTES.DASHBOARD_ACCESS_DENIED} />
      )}
    </>
  );
};

export default RoleGuard;
